import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Utility from "../../../common/utility";
import "../../../assets/css/components/Authentication/ChangePassword/ChangePassword.css";

const ChangePassword = inject("sharedStore")(observer(class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: "",
      password: "",
      confirmPassword: "",
      isEditable: false,
      passwordStatus: {
        passwordLength: {
          error: false,
          Msg: "Password must contain between 8 and 20 characters",
        },
        characterValue: {
          error: false,
          Msg: "Password must contain upper and lowercase letters",
        },
        specialCharacterValue: {
          error: false,
          Msg: "Password must contain at least one special character",
        },
        numericValue: {
          error: false,
          Msg: "Password must contain at least one number",
        },
        passwordMatch: {
          error: false,
          Msg: "New password and confirm password do not match.",
        },
      },
      isValidPassword: false,
      showPasswordErrorMessage: false,
      showConfirmPasswordErrorMessage: false,
      isPasswordError: false,
      isWrongOldPassword: false,
      clickedOutsidePassword: false,
      clickedOutsideConfirmPassword: false,
      responseError: false,
      responseMsg: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  handleChange(e) {
    const value = e.target.name;
    const { clickedOutsidePassword, password } = this.state;
    let { isWrongOldPassword, responseError, responseMsg } = this.state;
    if (responseError) {
      responseError = false;
      responseMsg = "";
      this.setState({ responseError, responseMsg });
    }
    if (e.target.name === "oldPassword" && isWrongOldPassword) {
      isWrongOldPassword = false;
      this.setState({ isWrongOldPassword });
    }
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (value === "password" && clickedOutsidePassword) {
          this.validatePassword();
        }
        if (value === "confirmPassword" && password !== "") {
          this.validateConfirmPassword();
        }
      }
    );
  }

  onFormSubmit() {
    this.props.sharedStore.showLoader();
    let data = {
      password: this.state.password,
      old: this.state.oldPassword,
    };
    fetch("api/user/changepassword/", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => {
        this.props.sharedStore.hideLoader();
        if (res.error === false) {
          this.setState({
            oldPassword: "",
            password: "",
            confirmPassword: "",
            isEditable: false,
            isValidPassword: false,
            showPasswordErrorMessage: false,
            showConfirmPasswordErrorMessage: false,
            isPasswordError: false,
            isWrongOldPassword: false,
          });
          let data = { successMessage: res.message };
          this.props.switchModalVisibility(null, 1, data);
        } else if (res.status_code === "401" || res.status_code === "402") {
          this.setState({ responseError: true, responseMsg: res.message });
        } else if (res.status_code === "400") {
          this.setState({
            isWrongOldPassword: true
          });
        }
      })
      .catch((error) => console.log(error));
  }

  handleEdit = () => {
    this.setState({
      isEditable: !this.state.isEditable,
      oldPassword: "",
      password: "",
      confirmPassword: "",
      isValidPassword: false,
      showPasswordErrorMessage: false,
      showConfirmPasswordErrorMessage: false,
      isPasswordError: false,
      isWrongOldPassword: false,
      responseError: false,
      responseMsg: "",
    });
  };

  validatePassword = () => {
    const { password, confirmPassword } = this.state;
    let {
      passwordStatus,
      showPasswordErrorMessage,
      isPasswordError,
      showConfirmPasswordErrorMessage,
      isValidPassword,
      clickedOutsidePassword,
    } = this.state;
    if (clickedOutsidePassword === false) {
      clickedOutsidePassword = true;
      this.setState({ clickedOutsidePassword });
    }
    const response = Utility.isValidPassword(password);
    passwordStatus.passwordLength.error = response.lengthError;
    passwordStatus.characterValue.error = response.characterValueError;
    passwordStatus.specialCharacterValue.error = response.specialCharacterError;
    passwordStatus.numericValue.error = response.numericValueError;
    if (confirmPassword !== "" && password !== confirmPassword) {
      passwordStatus.passwordMatch.error = true;
      isValidPassword = false;
      showConfirmPasswordErrorMessage = passwordStatus.passwordMatch.error
        ? true
        : false;
      this.setState({ isValidPassword, showConfirmPasswordErrorMessage });
    } else {
      passwordStatus.passwordMatch.error = false;
      isValidPassword = false;
      showConfirmPasswordErrorMessage = passwordStatus.passwordMatch.error
        ? true
        : false;
      this.setState({ isValidPassword, showConfirmPasswordErrorMessage });
    }
    isPasswordError =
      passwordStatus.passwordLength.error ||
      passwordStatus.characterValue.error ||
      passwordStatus.specialCharacterValue.error ||
      passwordStatus.numericValue.error
        ? true
        : false;
    if (password === confirmPassword && isPasswordError === false) {
      isValidPassword = true;
      this.setState({ isValidPassword });
    }
    showPasswordErrorMessage = !isPasswordError ? false : true;
    this.setState({
      showPasswordErrorMessage,
      passwordStatus,
      isPasswordError,
    });
  };

  validateConfirmPassword = () => {
    const { password, confirmPassword, isPasswordError } = this.state;
    let {
      passwordStatus,
      showConfirmPasswordErrorMessage,
      isValidPassword,
      clickedOutsidePassword,
      clickedOutsideConfirmPassword,
    } = this.state;
    if (clickedOutsideConfirmPassword === false) {
      clickedOutsideConfirmPassword = true;
      this.setState({ clickedOutsideConfirmPassword });
    }
    if (password !== confirmPassword) {
      passwordStatus.passwordMatch.error = true;
      isValidPassword = false;
    } else {
      passwordStatus.passwordMatch.error = false;
      isValidPassword = false;
    }
    if (
      password === confirmPassword &&
      clickedOutsidePassword &&
      isPasswordError === false
    ) {
      isValidPassword = true;
    }
    showConfirmPasswordErrorMessage = passwordStatus.passwordMatch.error
      ? true
      : false;
    this.setState({
      passwordStatus,
      showConfirmPasswordErrorMessage,
      isValidPassword,
    });
  };

  render() {
    const {
      passwordStatus,
      showPasswordErrorMessage,
      isPasswordError,
      showConfirmPasswordErrorMessage,
      isWrongOldPassword,
      oldPassword,
      responseError,
      responseMsg,
    } = this.state;
    return (
      <div className="update-password-section">
        <div className="d-flex field-group">
          <div className="flex-40">
            <label htmlFor="password">Current Password</label>
          </div>
          <input
            type="password"
            name="oldPassword"
            value={this.state.isEditable ? oldPassword : "***********"}
            onChange={this.handleChange}
            className={
              !isWrongOldPassword ? "form-control" : "form-control error-border"
            }
            id="password"
            placeholder=""
          />
        </div>
        {isWrongOldPassword ? (
          <div className="field-group msg_customError">
            <p className="error-true">
              <span className="fa fa-times error-true" />
              Incorrect password
            </p>
          </div>
        ) : null}
        {this.state.isEditable ? (
          <React.Fragment>
            <div className="d-flex field-group">
              <div className="flex-40">
                <label htmlFor="password">New Password</label>
              </div>
              <input
                type="password"
                name="password"
                onChange={this.handleChange}
                placeholder=""
                value={this.state.password}
                className={
                  !isPasswordError
                    ? "form-control"
                    : "form-control error-border"
                }
                onBlur={this.validatePassword}
                required
              />
            </div>
            {showPasswordErrorMessage ? (
              <div className="field-group msg_customError">
                <p
                  className={
                    passwordStatus.passwordLength.error
                      ? "error-true"
                      : "error-false"
                  }
                >
                  {passwordStatus.passwordLength.error ? (
                    <span className="fa fa-times error-true" />
                  ) : (
                    <span className="fa fa-check error-false" />
                  )}
                  {passwordStatus.passwordLength.Msg}
                </p>
                <p
                  className={
                    passwordStatus.characterValue.error
                      ? "error-true"
                      : "error-false"
                  }
                >
                  {passwordStatus.characterValue.error ? (
                    <span className="fa fa-times error-true" />
                  ) : (
                    <span className="fa fa-check error-false" />
                  )}
                  {passwordStatus.characterValue.Msg}
                </p>
                <p
                  className={
                    passwordStatus.specialCharacterValue.error
                      ? "error-true"
                      : "error-false"
                  }
                >
                  {passwordStatus.specialCharacterValue.error ? (
                    <span className="fa fa-times error-true" />
                  ) : (
                    <span className="fa fa-check error-false" />
                  )}
                  {passwordStatus.specialCharacterValue.Msg}
                </p>
                <p
                  className={
                    passwordStatus.numericValue.error
                      ? "error-true"
                      : "error-false"
                  }
                >
                  {passwordStatus.numericValue.error ? (
                    <span className="fa fa-times error-true" />
                  ) : (
                    <span className="fa fa-check error-false" />
                  )}
                  {passwordStatus.numericValue.Msg}
                </p>
              </div>
            ) : null}

            <div className="d-flex field-group">
              <div className="flex-40">
                <label htmlFor="password">Confirm Password</label>
              </div>
              <input
                type="password"
                name="confirmPassword"
                placeholder=""
                onChange={this.handleChange}
                value={this.state.confirmPassword}
                onBlur={this.validateConfirmPassword}
                className={
                  !passwordStatus.passwordMatch.error
                    ? "prompt-text form-control"
                    : "prompt-text form-control error-border"
                }
                required
              />
            </div>

            {showConfirmPasswordErrorMessage ? (
              <div className="field-group msg_customError">
                <p
                  className={
                    passwordStatus.passwordMatch.error
                      ? "error-true"
                      : "error-false"
                  }
                >
                  {passwordStatus.passwordMatch.error ? (
                    <span className="fa fa-times error-true" />
                  ) : (
                    <span className="fa fa-check error-false" />
                  )}
                  {passwordStatus.passwordMatch.Msg}
                </p>
              </div>
            ) : null}

            {responseError ? (
              <div className="field-group msg_customError">
                <p className="error-true">
                  <span className="fa fa-times error-true" />
                  {responseMsg}
                </p>
              </div>
            ) : null}
          </React.Fragment>
        ) : null}

        <div className="profile-btn-wrapper text-center">
          {this.state.isEditable ? (
            <React.Fragment>
              <button
                className="btn btn-common-secondary btn-profile-sm"
                type="button"
                onClick={this.handleEdit}
              >
                Cancel
              </button>
              <button
                disabled={
                  !this.state.isValidPassword || oldPassword.length === 0
                }
                onClick={this.onFormSubmit}
                className="btn btn-common btn-profile-sm ml-10"
                type="button"
              >
                Save
              </button>
            </React.Fragment>
          ) : (
            <button
              type="button"
              className="btn btn-common btn-profile-sm"
              value="Edit"
              onClick={this.handleEdit}
            >
              Update Password
            </button>
          )}
        </div>
      </div>
    );
  }
}));

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/Authentication/ChangePassword/ChangePassword.jsx